export default {
    root: {
        position: "relative",
        overflow: "inherit",
        display: "flow-root",
    },
};
